<div class="content-with-stepper-and-title">
  <div class="row mb-4">
    <div class="col-4 col-pr-12 col-sm-8 col-md-12">
      <div class="box-title" *ngIf="!abreCuentasService.viewOptionMultiProduct">
        <h2 class="sub-title" id="subtitle">{{screenCopies.title }} {{ documentInfo.firstname }}!
          {{ screenCopies.title_2 }} {{ subline }} {{ screenCopies.title_3 }} {{textApproved}} ${{ amountPco }}</h2>
      </div>
      <div class="box-desc" *ngIf="!abreCuentasService.viewOptionMultiProduct">
        <div class="detail">
          <div class="case-id">
            <p class="subtitle subtitle-light">{{ screenCopies.solicitud }}</p>
            <p> {{caseNum}} </p>
          </div>
        </div>
        <p class="copy-1 mt-3">{{ screenCopies.label }}</p>
        <div *ngIf="product_type =='freeInvestment' || product_type =='freeInvestment2'" class="detail">
          <div class="divider mt-3"></div>
          <div class="case-detail">
            <p><span>{{ screenCopies.text_zona_gris }}</span></p>
          </div>
          <div class="case-id">
            <p class="title_money">${{ amountPco }}</p>
            <p class="subtitle">{{ screenCopies.valor }}</p>
          </div>
          <div class="case-id">
            <p class="subtitle"><strong>{{ screenCopies.plazo }}</strong></p>
            <p> {{ mes }} meses </p>
          </div>
          <div class="case-id" *ngIf="showRate">
            <p class="subtitle"><strong>{{ screenCopies.tasa }}</strong></p>
            <p>{{ rateLiving }}</p>
          </div>
          <div class="case-detail">
            <p><span>{{ screenCopies.submaintext }}</span></p>
          </div>
        </div>
        <div *ngIf="product_type =='livingPlace' " class="detail">
          <div class="divider mt-3"></div>
          <div class="case-detail case-detail-bold">
            <p><span><strong>{{ labelDetail }}</strong></span></p>
          </div>
          <br>
          <div class="case-id">
            <p class="subtitle subtitle-light">{{ labelValue }}</p>
            <p class="money">${{ amountPco }}</p>
          </div>
          <div class="case-id">
            <p class="subtitle subtitle-light"><strong>{{ screenCopies.plazo }}</strong></p>
            <p> {{ mes }} meses </p>
          </div>
          <div class="case-id" *ngIf="showRate">
            <p class="subtitle subtitle-light"><strong>{{ screenCopies.tasa }}</strong></p>
            <p>{{ rateLiving }}</p>
            <p>{{screenCopies.copy_tasa}}</p>
          </div>
          <div *ngIf="purchase" class="case-id">
            <p class="subtitle subtitle-light">{{ screenCopies.compra }}</p>
            <p> {{ purchasePercent }}% del credito.</p>
          </div>
          <div class="divider mt-3"></div>
          <div class="case-detail">
            <p><span>{{ screenCopies.submaintext }}</span></p>
          </div>
        </div>
        <div class="box-desc">
          <div id="steps">
            <ul class="mt-3">
              <vcl-list>
                <li *ngFor="let option of options" vclListSimple>
                  <span id="iconCheck" class="icon icon-itaufonts_check">
                  </span>
                  <vcl-list-text class="list">
                    {{option.value.replace('%s',amountPco)}}
                  </vcl-list-text>
                </li>
              </vcl-list>
            </ul>
          </div>
        </div>
      </div>


      <div class="box-title" *ngIf="abreCuentasService.viewOptionMultiProduct">
        <h2 class="sub-title" id="subtitle">
          {{screenCopies.title }} {{ documentInfo.firstname }}! {{ screenCopies.mainText }}
        </h2>

        <div class="detail">
          <div class="case-id">
            <p class="subtitle subtitle-light">{{ screenCopies.solicitud }}</p>
            <p> {{caseNum}} </p>
          </div>
        </div>
        <div class="case-detail" *ngIf="!hasLoanProduct">
          <p><span>{{ screenCopies.submaintext }}</span></p>
        </div>

        <div class="class-detail" *ngIf="hasLoanProduct">
          <p class="mb-3"> <span> {{screenCopies.submaintext2}} </span> </p>

          <p> <span> {{screenCopies.consult_documents_text1}}
              <a (click)="goToSupportDocuments()">{{screenCopies.documentos}}</a>
              {{screenCopies.consult_documents_text2}}</span> </p>

          <p class="mt-3 mb-3"> <span> {{screenCopies.description2}} </span> </p>
        </div>

        <div class="list-product">
          <div class="product detail" *ngFor="let row of productsMulti">
            <strong>{{ row.name }}</strong>
            <br>
            <div class="case-id">
              <p class="subtitle subtitle-light">{{screenCopies.approved_value}}</p>
              <p class="money">$ {{getAmountProducts(row.product_type)}} *</p>
            </div>
            <div *ngIf="row.product_type == 'creditCard' || row.product_type == 'revolvingCredit'">
              <button class="btn-edit" type="submit" (click)="editOfert(row.product_type)">Modificar cupo</button>
            </div>
            <div class="divider mt-3"></div>
            <div *ngIf="row.product_type === 'freeInvestment'">
              <span>
                <strong>
                  {{screenCopies.plazo}}
                </strong>
              </span>
              <br>
              <span>{{rateTerm}} {{screenCopies.meses}}</span>
              <br>
              <br>
              <span><strong>{{screenCopies.tasa}}*</strong></span>
              <br>
              <span> {{rateLiving}} </span>
              <br>
              <span>{{screenCopies.tasa_two}}</span>
              <div class="divider mt-3"></div>
            </div>
            <voxel-accordion-group>
              <voxel-accordion accordionTitle="Beneficios" class="edithStyles">
                <ul>
                  <vcl-list *ngIf="row.product_type != 'creditCard' ">
                    <li *ngFor="let option of listBenefits(row)" vclListSimple>
                      <span id="iconCheck" class="icon icon-itaufonts_check">
                      </span>
                      <vcl-list-text class="list">
                        {{option.value.replace('%s',getAmountProducts(row.product_type))}}
                      </vcl-list-text>
                    </li>
                  </vcl-list>
                </ul>

                <div class="alliances" *ngIf="row.product_type == 'creditCard' ">
                  <div id="card_alliances" class="content-alliances">
                    <vcl-card-template *ngFor="let alliance of listBenefits(row)" image='assets/images/{{alliance.img}}'
                      [title]="alliance.name" [paragraph]="alliance.body" buttonAlignment="vertical">
                    </vcl-card-template>
                    <p class="copy-1 mt-3">{{ copyService.copies.message_grayzone_existent_find_more_information1 }}
                      <strong>Dias Itaú</strong>,
                      {{copyService.copies.message_grayzone_existent_find_more_information2}}
                    </p>
                    <br>
                    <a class="link" target="_blank">
                      {{copyService.copies.message_grayzone_existent_find_more_information_link}}
                    </a>
                    <br>
                  </div>
                </div>
              </voxel-accordion>
            </voxel-accordion-group>
          </div>
        </div>

      </div>

    </div>
  </div>
  <app-controls id="offer" [previousLabel]="copyService.copies.offer_resolvinf_credit.volver" [hasPrevious]="true"
    [nextLabel]="copyService.copies.offer_resolvinf_credit.button" (previous)="previous()" (next)="checkBioCatch()">
  </app-controls>
</div>